import * as React from 'react';
import classNames from 'classnames';
import { basePageWrap } from '../BasePage';
import CardOffer from '../../components/CardOffer';

import Streamfield from '../../components/Streamfield';

import s from './CareerPage.module.scss';

interface CareerPageProps {
    title: string,
    heading: string,
    preamble: string,
    items: Array<any>,
    content: Array<any>,
}

class CareerPage extends React.PureComponent<CareerPageProps> {
    state = {};

    static defaultProps = {};

    render() {
        const { title, heading, preamble, items } = { ...this.props };

        return (
            <>
                <div className={s.Root}>
                    <div className={s.HeaderWrap}>
                        {heading &&
                            <h1 className={s.Title} dangerouslySetInnerHTML={{ __html: heading }} />
                        }
                        {!heading && title &&
                            <h1 className={s.Title}>{title}</h1>
                        }
                        {preamble && (
                            <p className={s.Preamble}>{preamble}</p>
                        )}
                    </div>

                    {items && (
                        <Streamfield items={items} pageType="CareerPage" />
                    )}
                </div>
            </>
        )
    }
}

export default basePageWrap(CareerPage);
